export const isChartTitleHidden = ({tile, size}) => {
    const ruleMap = {
        MapTile: size.width <= 6 || size.height <= 3, // AB#1079
        TextLabelTile: size.height < 2,
    };
    return ruleMap[tile.$type];
};
